import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  loader: {
    height: '100vh',
    width: '100vw',
    top: 0,
    left: 0,
    position: 'fixed',
    backgroundColor: token.colorWhite,
    zIndex: 1000
  }
}))
